<template>
  <div>
    <Dialog header="Header" :visible.sync="displayDuplicateMessage" >
      <template #header>
        <h3>Duplicate error</h3>
      </template>

      The following Contact seems to be a duplicate of the contact you are trying to save. Please confirm if you wish to still save this contact?
      
      <ul>
        <li v-for="(info, key, index) in contact" :key="index">
          <strong>{{key}}&nbsp;-</strong>
          &nbsp;&nbsp;
          <span v-if="info && info.jobTitleDesc">{{info.jobTitleDesc}}</span>
          <span v-else-if="info && info.salutation">{{info.salutation}}</span>
          <span v-else-if="info && info.fullName">{{info.fullName}}</span>
          <span v-else>{{info}}</span>
        </li>
      </ul>

      <template #footer>
        <Button 
          @click="closeDuplicate()" 
          label="No" 
          icon="pi pi-times" 
          class="p-button-text"
        />
        <Button 
          @click="sendDuplicate()"
          label="Yes" 
          icon="pi pi-check" 
          autofocus 
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
export default {
  props: [
    'duplicateDialog',
    'contact'
  ],
  computed: {
    displayDuplicateMessage: {
      set(val) {
        if (!val) {
          this.closeDuplicate()
        }
      },
      get() {
        return this.duplicateDialog ? true : false
      }
    }
  },
  methods: {
    sendDuplicate() {
      this.$emit('submit-duplicate-form')
    },
    closeDuplicate() {
      this.$emit('hide-duplicate-dialog')
    }
  }
}
</script>

<style>

</style>